<div
  class="body"
  nz-tooltip
  [nzTooltipTitle]="getToolTip()"
  [ngStyle]="getStyle()"
  (click)="onClick()"
  (mouseleave)="onMouseLeave()"
  (mouseenter)="onMouseEnter()"
>
  <app-board-icon [size]="size" [board]="board" [showTooltip]="false" [hideUserStatus]="false"></app-board-icon>
  <div>{{ getBoardName(board) }}</div>
</div>
